import styled from 'styled-components'
import { Pill, Skeleton } from '@sketch/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  height: 100%;
`

export const StyledSkeleton = styled(Skeleton)`
  width: auto;
  margin: 20px;
  height: 40px;
`
export const ExportsWrapper = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;

  border-top: 1px solid ${({ theme }) => theme.colors.border.A};
  /* to hide the previous section's border */
  margin-top: -1px; /* stylelint-disable-line scales/space */

  /* Make sure the overlay has the same color as the parent */
  background: var(
    --background-color,
    ${({ theme }) => theme.colors.background.secondary.A}
  );
`

export const EmptyStateSeparator = styled.hr`
  width: 160px;
  display: flex;
  margin: 24px auto;
`

export const EmptyStateShortCutPill = styled(Pill)`
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  background-color: ${({ theme }) => theme.colors.background.tertiary.B};
  padding: 4px 6px; /* stylelint-disable-line scales/space */
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fontSizes.D};
`
